import { Button, Modal } from "antd";
import { observer } from "mobx-react";
import { useMobxStores } from "../stores/stores";

const ConfirmDeleteModal = ({
  learningGraph,
  isOpen,
  setIsOpen,
  handleCancelDelete,
}) => {
  const { learningGraphStore } = useMobxStores();

  const handleDelete = async () => {
    await learningGraphStore.DeleteLearningGraph(learningGraph);
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleCancelDelete}
      footer={[
        <Button onClick={handleCancelDelete}>No</Button>,
        <Button type="primary" onClick={handleDelete}>
          Yes
        </Button>,
      ]}
    >
      Are you sure you want to delete this item?
    </Modal>
  );
};

export default observer(ConfirmDeleteModal);
